const config = require('../config')
const apiConfig = require('../api-config')
const apiFactory = require('../resources/multisignatory/api-factory')
const serviceFactory = require('../resources/multisignatory/service-factory')

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/multisig-service/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  })

  const service = serviceFactory({ api })

  const p = '[{keys:metaData}].'

  return (app) => app
  .match(`${p}multisignatory.validateMultisignPayment[{keys:details}][{keys:guidStr}]`, (requests) =>
      Promise.all(
        requests.map(({ req, res }) =>
          service
            .validateMultisignPayment(req.params.details, req.params.metaData)
            .then((xs) => res.value(xs))
            .catch(res.error)
        )
      )
    )
  .match(`${p}multisignatory.resumeMultisignPayment[{keys:details}][{keys:guidStr}]`, (requests) =>
      Promise.all(
        requests.map(({ req, res }) =>
          service
            .resumeMultisignPayment(req.params.details, req.params.metaData)
            .then((xs) => res.value(xs))
            .catch(res.error)
        )
      )
    )
  .match(`${p}multisignatory.fetchMultiSignNotification[{keys:inputParam}][{keys:guidStr}]`, requests => 
      Promise.all(
       requests.map(({ req, res }) =>
        service.fetchMultiSignNotification(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )
    )
  )
}

module.exports = addRoutes